<template>
  <v-col v-if="demandes">
    <v-form
      lazy-validation
      ref="formAdresse"
      v-model="validFormAdresse"
      @submit.prevent
    >
      <p>Saisissez votre nouvelle adresse dans l’encart ci-après :</p>
      <v-textarea
        v-model="DepotPiece.contenu"
        filled
        name="Adresse postale"
        label="Adresse postale"
        :rules="[
          (value) => !!value || 'Champ requis.',
          (v) =>
            (v || '').length <= 250 ||
            `le nombre de caractères doit être inférieur à 250.`,
        ]"
        required
        auto-grow
        counter="250"
      ></v-textarea>

      <v-btn
        class="mx-2"
        :disabled="!validFormAdresse"
        color="success"
        @click="validerFormAdresse"
        ><v-icon left>mdi-magnify</v-icon>Valider</v-btn
      >
    </v-form>

    <v-data-table v-if="demandes" :headers="headers" :items="demandes">
      <template v-slot:[`item.validation`]="{ item }">
        <v-chip v-if="item.validation == null" color="warning">
          en cours
        </v-chip>
        <v-chip v-else-if="item.validation == 0" color="error">refusé</v-chip>
        <v-chip v-else-if="item.validation == 1" color="success"
          >accepté</v-chip
        >
      </template>
      <template v-slot:[`item.createAt`]="{ item }">
        <v-col>{{
          item.createAt
            ? new Date(item.createAt).toLocaleString("fr-FR", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            : ""
        }}</v-col>
      </template>
      <template v-slot:[`item.messagerie`]="{ item }">
        <v-col>
          <v-badge
            :color="
              item.nombreMessagesUtilisateur <= 0 ? 'transparent' : 'primary'
            "
            :content="item.nombreMessagesUtilisateur"
          >
            <v-btn
              icon
              @click="lancerMessagerie(item)"
              :color="item.nombreMessagesUtilisateur > 0 ? 'red' : 'grey'"
              ><v-icon>messagerie</v-icon></v-btn
            >
          </v-badge>
        </v-col>
      </template>
    </v-data-table>
    <br />
    <messagerie ref="messagerie" :temoinGestionnaire="false"></messagerie>
  </v-col>
</template>

<script>
import ApiDepotPieceRepository from "@/repositories/ApiDepotPieceRepository";
import messagerie from "@/components/Messagerie";

export default {
  components: { messagerie },
  data() {
    return {
      validFormAdresse: false,
      DepotPiece: {
        type: "",
        libelle: "adresse",
        contenu: null,
        validation: null,
      },
      headers: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Date de création",
          value: "createAt",
        },
        {
          text: "Type",
          value: "type",
        },
        {
          text: "Statut",
          value: "validation",
        },
        {
          text: "Adresse postale",
          value: "contenu",
        },
        {
          text: "Messagerie",
          value: "messagerie",
        },
        {
          text: "Message de refus",
          value: "messageRefus",
        },
      ],
      demandes: [],
      dialogMessagerie: false,
      demandeMessagerie: null,
    };
  },
  async created() {
    this.demandes = await ApiDepotPieceRepository.getDemandesByType("adresse");
    this.demandes.reverse();
    this.DepotPiece.type = "adresse";
    console.log(this.demandes);
  },
  methods: {
    validerFormAdresse() {
      if (this.$refs.formAdresse.validate()) {
        this.$confirm(
          "<strong>ATTENTION, en validant ce dossier vous ne pourrez plus le modifier. " +
            "Cliquez sur 'Oui' pour confirmer votre demande ou sur 'Non' pour revenir à l'écran précédent.</strong>"
        ).then(async (response) => {
          if (response) {
            this.demandes.unshift(
              await ApiDepotPieceRepository.saveAdresse(this.DepotPiece)
            );
            this.$refs.formAdresse.reset();
          }
        });
      }
    },
    lancerMessagerie(item) {
      this.$refs.messagerie.openMessagerie(item);
      this.nombreMessagesUtilisateur = 0;
    },
  },
};
</script>
